module.exports = __webpack_public_path__ + "a11e24b4d1cfbe68826f02c5ee5db865.fbx";